import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './pages/auth/Auth';
import { BrowserRouter } from 'react-router-dom';

// Suppress benign ResizeObserver errors from charting libraries in development
window.addEventListener('error', e => {
  if (e.message === 'ResizeObserver loop limit exceeded' || e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) resizeObserverErr.setAttribute('style', 'display: none');
    if (resizeObserverErrDiv) resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>

    <BrowserRouter>
      <App />
    </BrowserRouter>

  </AuthProvider>
);
reportWebVitals();
